import React from 'react';
import PropTypes from 'prop-types';

const SeoOnlyLink = ({
  to,
  children,
  onClick,
  ...linkProps
}) => {
  const preventClick = (e) => {
    onClick && onClick(e);
    e.preventDefault();
    return false;
  }
  return (
    <a href={to} {...linkProps} onClick={preventClick}>{children}</a>
  );
}


SeoOnlyLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
};

SeoOnlyLink.defaultProps = {
  onClick: undefined
};

export default SeoOnlyLink;
